import React, { ReactNode, createContext } from 'react';
import { PrivateArchivalUnit } from 'types';

type PrivateArchivalUnitContextType = {
  privateArchivalUnit?: PrivateArchivalUnit;
};

export const PrivateArchivalUnitContext = createContext<
  PrivateArchivalUnitContextType
>({});

export const PrivateArchivalUnitProvider = ({
  children,
  privateArchivalUnit,
}: {
  children: ReactNode;
  privateArchivalUnit?: PrivateArchivalUnit;
}) => {
  return (
    <PrivateArchivalUnitContext.Provider value={{ privateArchivalUnit }}>
      {children}
    </PrivateArchivalUnitContext.Provider>
  );
};
